import { getAppEnvironment } from '../utils/getAppEnvironment'
import { getIsAppTestingEnvironment } from '../utils/getIsAppTestingEnvironment'

export const useAppEnvironment = () => {
  return {
    environment: getAppEnvironment(),
    isTestingEnvironment: getIsAppTestingEnvironment(),
  }
}
